import styled from 'styled-components'

export const ProfileSettingContainerSection = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	height: 100%;
	margin-top: 30px;
`
